import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ProgramsPage } from './pages/ProgramsPage';
import { FacilityPage } from './pages/FacilityPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PersonalSafetyPage } from './pages/PersonalSafetyPage';
import { ChildBenefitsPage } from './pages/ChildBenefitsPage';
import { TeenBenefitsPage } from './pages/TeenBenefitsPage';
import { AdultBenefitsPage } from './pages/AdultBenefitsPage';
import { FamilyBenefitsPage } from './pages/FamilyBenefitsPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/programs" element={<ProgramsPage data-id="element-5" />} data-id="element-4" />
        <Route path="/facility" element={<FacilityPage data-id="element-7" />} data-id="element-6" />
        <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
        <Route path="/contact" element={<ContactPage data-id="element-11" />} data-id="element-10" />
        <Route path="/personal-safety" element={<PersonalSafetyPage data-id="element-13" />} data-id="element-12" />
        <Route path="/child-benefits" element={<ChildBenefitsPage data-id="element-15" />} data-id="element-14" />
        <Route path="/teen-benefits" element={<TeenBenefitsPage data-id="element-17" />} data-id="element-16" />
        <Route path="/adult-benefits" element={<AdultBenefitsPage data-id="element-19" />} data-id="element-18" />
        <Route path="/family-benefits" element={<FamilyBenefitsPage data-id="element-21" />} data-id="element-20" />
      </Routes>
    </Router>;
}